<template>
  <BoiteDesCouleurs3/>
</template>

<script>
// @ is an alias to /src
import BoiteDesCouleurs3 from '@/components/boites-des-couleurs/BoiteDesCouleurs3.vue'

export default {
  name: 'BoiteDesCouleurs3Page',
  components: {
    BoiteDesCouleurs3
  }
}
</script>
